import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { handleOrderableParameters } from "../_helpers/handle-parameters";

export const GROUPS_BY_USER_RESOURCE = "group" as const;
export const GROUPS_BY_USER_OPERATION = "user" as const;
export const GROUPS_BY_USER_API_PATH = `/v1/${GROUPS_BY_USER_RESOURCE}/${GROUPS_BY_USER_OPERATION}/{uuid}` as const;

export type GroupsByUserResponse =
  paths[typeof GROUPS_BY_USER_API_PATH]["get"]["responses"][200]["content"]["application/json"];
export type GroupsByUserParams = paths[typeof GROUPS_BY_USER_API_PATH]["get"]["parameters"]["query"];

export const useGroupsByUserQuery = (userUuid: string, params?: GroupsByUserParams) => {
  const processedParams = params ? handleOrderableParameters(params) : {};

  return useQuery({
    enabled: !!userUuid,
    queryKey: [GROUPS_BY_USER_RESOURCE, GROUPS_BY_USER_OPERATION, userUuid, processedParams.orderBy],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<GroupsByUserResponse>(
        `/v1/${GROUPS_BY_USER_RESOURCE}/${GROUPS_BY_USER_OPERATION}/${userUuid}`,
        { params: processedParams },
      );

      return response.data;
    },
  });
};
